import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Participant } from '@vendasta/conversation';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { CONVERSATION_HOST_APP_INTERFACE_TOKEN } from '../../../../core/src/lib/tokens';
import { formatPhoneNumber } from '@vendasta/galaxy/pipes/src/phone-number/phone-number.pipe';

@Component({
  selector: 'inbox-conversation-title',
  templateUrl: './inbox-conversation-title.component.html',
  styleUrls: ['./inbox-conversation-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [NgClass, TranslateModule],
})
export class InboxConversationTitleComponent {
  private readonly hostAppInterface = inject(CONVERSATION_HOST_APP_INTERFACE_TOKEN);

  conversationDetail = input<ConversationDetail>();
  conversationClosed = input<boolean>(false);
  displayOnTopBar = input<boolean>(false);

  isInternalInfoDeleted = computed(() => {
    const detail = this.conversationDetail();
    return detail ? this.hostAppInterface.isRecipientInternalInfoDeleted(detail) : false;
  });

  formattedTitle = computed(() => {
    const detail = this.conversationDetail();
    const titleText = detail ? this.hostAppInterface.getConversationTitleInfo(detail).title : '';

    if (!titleText) {
      const recipient = detail ? this.hostAppInterface.getRecipient(detail) : null;
      const phone = Array.isArray(recipient) ? recipient[0]?.phoneNumber : (recipient as Participant | null)?.phoneNumber;
      return phone ? formatPhoneNumber(phone, true) : '';
    }

    if (titleText.startsWith('instagram_user')) {
      return titleText;
    }

    return formatPhoneNumber(titleText, true);
  });
}
